
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { exportNotification } from '../../../apis/messageListApi';
import { app } from "@microsoft/teams-js";
import './ExportButton.scss'
import { Button, Spinner, Tooltip } from "@fluentui/react-components"
import { ArrowDownload24Filled } from "@fluentui/react-icons"

const ExportButton = () => {
    const [sendingRequest, setSendingRequest] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>();
    const [teamId, setTeamId] = useState<string | undefined>(undefined);
    const [t, i18n] = useTranslation();

    useEffect(() => {
        app.getContext().then((context: app.Context) => setTeamId(context.team?.internalId));
    }, []);

    const sendExportRequest = async (event: any) => {
        setErrorMessage("");
        setSendingRequest(true);
        let payload = {
            teamId: teamId,
            isAll: true
        };
        await exportNotification(payload).then(() => {
            setSendingRequest(false);
        }).catch(() => {
            setErrorMessage("Something went wrong")
            setSendingRequest(false);
        });
    }

    return (
        <div className="exportButton">
            {sendingRequest && <Spinner id="sendingLoader" size="extra-small" label={t("ExportLabel")} labelPosition="after" />}
            {errorMessage}
            <Tooltip content={"Export detailed result (1 year)"} relationship='label'>
                <Button disabled={!teamId && sendingRequest} icon={<ArrowDownload24Filled />} onClick={sendExportRequest} appearance='primary'>Full Export</Button>
            </Tooltip>
        </div>
    )
}

export default ExportButton;